import { ChangeDetectionStrategy, Component, input, output, TemplateRef } from '@angular/core';
import { ServiceStateEnum } from '@mwe/constants';
import { AlertType, InlineNotificationType } from '@mwe/models';
import { NgTemplateOutlet } from '@angular/common';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { LoadingSpinnerComponent } from '../loading-module/loading/loading-spinner.component';
import { LoadingSpinnerExtendedComponent } from '../loading-module/loading/loading-spinner-extended.component';
import { LoadingSpinnerExtendedWhiteBackgroundComponent } from '../loading-module/loading/loading-spinner-extended-white-background.component';
import { InlineNotificationComponent } from '../inline-notification/inline-notification.component';
import { AlertComponent } from '../alert/alert.component';
import { SpecialAlertComponent } from '../alert/special-alert.component';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'mwe-pre-load-data',
  templateUrl: './pre-load-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    BasicCardComponent,
    LoadingSpinnerComponent,
    LoadingSpinnerExtendedComponent,
    LoadingSpinnerExtendedWhiteBackgroundComponent,
    InlineNotificationComponent,
    AlertComponent,
    SpecialAlertComponent,
    EmptyStateComponent,
  ],
})
export class PreLoadDataComponent {
  state = input<ServiceStateEnum>();
  alertTitleKey = input<string>('newClient.status.loadError.key');
  alertMessageKey = input<string>('newClient.status.loadError.text');
  alertType = input<AlertType>('danger');
  inlineNotificationType = input<InlineNotificationType>(null); // will replace alertType
  errorPlaceholderMap = input<Map<string, string>>();
  successTemplate = input.required<TemplateRef<any>>();
  errorTemplate = input<TemplateRef<any>>();
  loadingTemplate = input<TemplateRef<any>>();
  specialAlertError = input<boolean>(false);
  loadingSpinnerType = input<'normal' | 'normal-without-box' | 'extended' | 'extended-white-background'>('normal');
  loadingSpinnerText = input<string>();
  reloadButtonKey = input<string>();
  reloadButtonClicked = output();
  ServiceStateEnum = ServiceStateEnum;

  // Unified error display.
  errorType = input<'noData' | 'error'>(undefined);
}
